module.exports = __webpack_public_path__ + "img/frame-top.75ae23a3.webp";